// extracted by mini-css-extract-plugin
module.exports = {"navBarTeam":"styles_navBarTeam__2exXA","teamsContainer":"styles_teamsContainer__1UQvJ"};